import { Component, OnInit,HostListener,LOCALE_ID, AfterViewInit, OnDestroy, EventEmitter, Output} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
declare let $: any;
import * as _ from 'underscore';
import { TranslateService } from "@ngx-translate/core";
import { UserDetailsService } from '../../services/user-details.service';
import { AjaxService } from '../../services/ajax.service';
import { Utility } from '../../shared/utility/utility';
import { CustomValidators } from '../../shared/utility/custom-validator';
import { EmitterService } from '../../services/emitter.service';
import { ProfileSettingService } from '../../services/profile-setting.service';
import { dateMobiScroll, transactionTypeConfs, transactionTypeForALL, NegativeTxns, PostiveTxns } from '../../shared/utility/config';
import { MyaccountSharedComponent } from '../myaccount-shared/myaccount-shared.component';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  providers:[
  {
    provide: LOCALE_ID,
    deps: [UserDetailsService],      //some service handling global settings
    useFactory: (userDetailsService) => userDetailsService.getLanguage()  //returns locale string
  }],
  styleUrls: ['./transaction.component.scss']
})
export class TransactionComponent extends MyaccountSharedComponent implements OnInit, AfterViewInit, OnDestroy {
  transactions:any;
  userId:any;
  minimumDate = new Date();
  request:any={
    interval:{
      end:new Date(),
    },
    size:10,
    index:0
  }
  totalBalance;
  cashBalance;
  bonusBalance;
  txnTypes;
  mobiDatePicker;
  userDetail;
  startdate;
  enddate;
  windowType;
  serverError;
  maxDate = new Date();
  langCode;
  noOfTransactions=11;
  noOfNewTransactions=10;
  destroy$: Subject<boolean> = new Subject<boolean>();
  @Output() triggerAccountMenu = new EventEmitter<{}>();

  // /*Picking up date change events from mobiscroll on mobile*/
  // mobiDatePicker_start = {
  //   theme: 'ios',
  //   display: 'bottom',
  //   width: 200,
  //   onSet:(event, inst) =>{
  //     this.dateChangeHandler('enddate','mobile');
  //   }
  // }
  // mobiDataPicker_end = {
  //   theme: 'ios',
  //   display: 'bottom',
  //   width: 200,
  //   onSet: (event, inst) => {
  //     this.dateChangeHandler('startdate','mobile');
  //   }
  // }
  @HostListener('window:resize') onResize() {
    // guard against resize before view is rendered
    const ww = document.body.clientWidth;
    if(ww <= 992){
      this.windowType = "mobile";
    }else{
      this.windowType = "device";
    }
  }

  txnDetails = this.formBuilder.group({
    'startDate': ['', [this.customValidators.required]],
    'endDate': ['', [this.customValidators.required]],
    'items': ['ALL', [this.customValidators.required]]
  });

  //,{validator: this.customValidators.startEndDateCheck} // Validation not required as one date auto changes when the other is changed

  constructor(
    private ajaxService : AjaxService,
    private utils:Utility,
    private formBuilder:FormBuilder,
    public userDetailsService:UserDetailsService,
    public datePipe: DatePipe,
    public customValidators: CustomValidators,
    private emitterService: EmitterService,
    private router: Router,
    private profileSettingService:ProfileSettingService,
    private translationService: TranslateService,
    private myaccountSharedComponent: MyaccountSharedComponent
   ) {
    super(utils);
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode =>{
      this.langCode = langCode;
    });

    this.userDetailsService.userBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe(message => {
      this.totalBalance=this.userDetailsService.getUserBalanceDetails();
      this.cashBalance=this.userDetailsService.getUserCashBalance().toFixed(2).toString();
      this.bonusBalance=this.userDetailsService.getUserBonusBalance().toFixed(2).toString();
    
    });
  }
    
    ngOnInit() {
      this.mobiDatePicker = dateMobiScroll;
      if(!this.utils.isUserLoggedIn()){
        this.router.navigate([this.langCode+'/login']);
      }
      this.emitterService.broadcastActiveTabChangeSource("transactions");
      this.txnTypes = transactionTypeConfs;
      this.totalBalance=this.userDetailsService.getUserBalanceDetails();
      this.cashBalance=this.userDetailsService.getUserCashBalance().toFixed(2).toString();
      this.bonusBalance=this.userDetailsService.getUserBonusBalance().toFixed(2).toString();
      let date = new Date();
      this.startdate = new Date(date.setDate(date.getDate() - 7));
      this.enddate = new Date();
      this.request={
        interval: {
          start: this.startdate,
          end: this.enddate,
        },
        size:this.noOfTransactions,
        index:0
      }
      this.getTransactionDetails(this.request,"");
      Promise.resolve(this.profileSettingService.getProfileData(false)).then(profileData => {
        if (!profileData) {
          this.serverError = this.translationService.instant('errors.error9')//"Failed to get the details of the user,due to server problem. Try after sometime";
          this.emitterService.broadcastserverError(this.serverError, "/myaccount/transactions");
        } else {
          this.userDetail = this.userDetailsService.getUserProfileDetails();
        }
      });
    }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowType = document.body.clientWidth <= 992 ? "mobile" : "device";
      this.txnDetails.controls["startDate"].setValue(this.startdate.toISOString().substring(0, 10));
      this.txnDetails.controls["endDate"].setValue(this.enddate.toISOString().substring(0, 10));
      this.txnDetails.controls["items"].setValue("ALL");
      MyaccountSharedComponent.formgroup = this.txnDetails;
    });
  }
  goBack(){
    this.emitterService.broadCastToggleNavPanel(true);
    this.utils.setIsSideMenuOpened(true);
    // this.triggerAccountMenu.emit(true);
  }
  getTransactionDetails(getData,buttonId):void{
    this.transactions = undefined;
    let transcationTypes;
    if(this.txnDetails.controls["items"].value.length === 0){
      this.txnDetails.controls["items"].setValue("ALL");
    }
    switch(this.txnDetails.controls["items"].value){
      case 'ALL' :
        transcationTypes = transactionTypeForALL;
        break;
      case 'NEGATIVE' :
        transcationTypes = NegativeTxns;
        break;
      case 'POSITIVE' :
        transcationTypes = PostiveTxns;
        break;
      default :
        transcationTypes = [this.txnDetails.controls["items"].value];
    }

    this.request = {
      index: getData.index ? getData.index : 0,
      size: getData.size ? getData.size :this.noOfTransactions,
      order: true,
      transactionTypes:transcationTypes,
      interval:getData.interval
    }
    Promise.resolve(this.ajaxService.getUserTransactionsHistory(this.request)).then(data => {
      if(!data){
        this.serverError = this.translationService.instant('errors.error6')//"Failed to get the history.Try after sometime";
        this.emitterService.broadcastserverError(this.serverError, "/myaccount/transactions");
      }else{
        if(buttonId){
          this.utils.enableButton(buttonId,"Filter");
        }
        this.transactions = data?.length ? data.sort((x, y) => y.time - x.time) : [];
      }
    },SystemError => {
      this.serverError = this.translationService.instant('errors.error6')//"Failed to get the history.Try after sometime";
      this.emitterService.broadcastserverError(this.serverError, "/myaccount/transactions");
    });
  }

  applyFilter(buttonId,more):void{
    if(buttonId){
      this.utils.disableNewButton(buttonId);
    }
    if(more === 'more'){
      this.request.index = this.request.index + this.noOfNewTransactions;
    }else if(buttonId === 'filterButton'){
      this.request.index = 0;
    }else{
      this.request.index = this.request.index ? this.request.index - this.noOfNewTransactions : 0;
    }
    this.request={
      interval:{
        start:new Date(this.txnDetails.controls["startDate"].value),
        end:new Date(this.txnDetails.controls["endDate"].value),
      },
      size:this.noOfTransactions,
      index: this.request.index
    }
    this.getTransactionDetails(this.request,buttonId);
  }

  toggleAccordion(): void{
    const accordionRow = $("#mobAcc");
    const accordionHeader = accordionRow.find('.accordionHeadline');
    const accordionConent = accordionRow.find('.accordionText');

    if (!accordionConent.hasClass('activeAccordionText')) {
      $('.accordionHeadline').removeClass('flipButton');
      accordionHeader.addClass('flipButton');
      $('.accordionText').removeClass('activeAccordionText');
      accordionConent.addClass('activeAccordionText');
    }else if (accordionConent.hasClass('activeAccordionText')) {
      accordionHeader.removeClass('flipButton');
      accordionConent.removeClass('activeAccordionText');
    }
  }
  /* Function called on event : Date change through mobiscroll on mobile*/
  // dateChangeHandler(target, deviceType?) {   
  //   this.resetDate(target);
  // }
   /*
    Function for resetting date : if user selects startdate then auto change the end date.
    If user selects the end date auto select the start date. 
    This function is called by both device and mobile.
  */
  // resetDate(target: String) {
  //   var startdate = new Date(this.txnDetails.controls["startDate"].value);
  //   var copyStartDate = new Date(this.txnDetails.controls["startDate"].value);
  //   var enddate = new Date(this.txnDetails.controls["endDate"].value);
  //   var copyEndDate = new Date(this.txnDetails.controls["endDate"].value);
  //   if (target === "enddate") {
  //     var sevenDaysAheadDate = new Date(copyStartDate.setDate(copyStartDate.getDate() + 7));
  //     if ((new Date(this.txnDetails.controls["endDate"].value) > sevenDaysAheadDate) || (startdate > enddate)) {
  //       this.enddate = new Date(startdate.setDate(startdate.getDate() + 7));
  //       if (this.enddate > new Date()) {
  //         this.enddate = new Date();
  //       }
  //     } else {
  //       this.enddate = enddate;
  //     }
  //     this.txnDetails.controls["endDate"].setValue(this.enddate);
  //   } else {
  //     var sevenDaysAgoDate = new Date(copyEndDate.setDate(copyEndDate.getDate() - 7));
  //     if ((new Date(this.txnDetails.controls["startDate"].value) < sevenDaysAgoDate) ||  (startdate > enddate)) {
  //       this.startdate = new Date(enddate.setDate(enddate.getDate() - 7));
  //     } else {
  //       this.startdate = startdate;
  //     }
  //     this.txnDetails.controls["startDate"].setValue(this.startdate);
  //   }
  // }
  
  ngOnDestroy(){
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
